import Styled from 'styled-components';

const AuthenticationWrap = Styled.div`
  position: relative;
  padding: 120px 0;
  background-position: top;
  background-repeat: no-repeat;
  background-size: 100%;
  @media only screen and (max-width: 1399px){
    padding: 15px 0 0;
  }
  .ninjadash-authentication-wrap{
    @media only screen and (max-width: 767px){
      padding: 0 15px;
    }
  }
  .ninjadash-authentication-brand{
    text-align: center;
  }
`;

const OAuthAuthenticationWrap = Styled.div`
  position: relative;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 120px 0;
  font-family: 'Work Sans', sans-serif;
  background-position: top;
  background-repeat: no-repeat;
  background-size: 100%;
  @media only screen and (max-width: 1399px){
    padding: 15px 0 0;
  }
  .ninjadash-authentication-wrap{
    width: 100%;
    @media only screen and (max-width: 767px){
      padding: 0 15px;
    }
  }
  .ninjadash-authentication-brand{
    text-align: center;
  }
  .oauth-spinner-row {
    padding-top: 80px;
  }
  .oauth-spinner-icon {
    font-size: 36px;
  }
`;

const Content = Styled.div`
    padding: 100px;
    @media only screen and (max-width: 1599px){
      padding: 50px;
    }
    @media only screen and (max-width: 991px){
      padding: 20px;
    }
    @media only screen and (max-width: 767px){
      text-align: center;
    }
    .auth-content-figure{
      @media only screen and (max-width: 1199px){
        max-width: 420px;
      }
      @media only screen and (max-width: 991px){
        max-width: 100%;
      }
    }
`;

const AuthFormWrap = Styled.div`
  border-radius: 6px;
  margin-top: 25px;
  box-shadow: 0 5px 20px rgba(140,144,164,.08);
  background-color: ${({ theme }) => theme[theme.mainContent]['white-background']};
  .ninjadash-authentication-top{
    padding: 20px;
    text-align: center;
    border-bottom: 1px solid ${({ theme }) => theme[theme.mainContent]['border-color-secondary']};
    .ninjadash-authentication-top__title{
      font-size: 20px;
      font-weight: 600;
      line-height: 1;
      margin-bottom: 0;
      color: ${({ theme }) => theme[theme.mainContent]['dark-text']};
    }
    .ninjadash-authentication-top__subtitle {
      font-size: 13px;
      color: ${({ theme }) => theme[theme.mainContent]['light-text']};
      margin-top: 8px;
      margin-bottom: 0;
      strong {
        color: ${({ theme }) => theme[theme.mainContent]['dark-text']};
      }
    }

    /* ── OAuth consent: AI→User icon row ── */
    .oauth-icons-row {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 16px;
    }
    .oauth-icon-ai {
      width: 44px; height: 44px;
      border-radius: 6px;
      border: 1px solid ${({ theme }) => theme[theme.mainContent]['border-color-secondary']};
      background: ${({ theme }) => theme[theme.mainContent]['white-background']};
      color: ${({ theme }) => theme[theme.mainContent]['dark-text']};
      box-shadow: 0 5px 20px rgba(140,144,164,0.08);
      display: flex; align-items: center; justify-content: center;
      font-size: 13px; font-weight: 700; letter-spacing: -1px;
      flex-shrink: 0;
    }
    .oauth-icon-connector {
      display: flex; align-items: center;
      padding: 0 8px;
      color: ${({ theme }) => theme[theme.mainContent]['extra-light-text']};
    }
    .oauth-icon-dot {
      display: inline-block;
      width: 5px; height: 5px; border-radius: 50%;
      background: currentColor; flex-shrink: 0;
    }
    .oauth-icon-dash {
      display: inline-block;
      width: 20px; height: 1.5px;
      background: currentColor; flex-shrink: 0; margin: 0 2px;
    }
    .oauth-icon-arrow { display: inline-block; font-size: 16px; line-height: 1; }
    .oauth-icon-user {
      width: 44px; height: 44px;
      border-radius: 6px;
      background: ${({ theme }) => theme['primary-color']};
      color: #fff; font-size: 20px;
      display: flex; align-items: center; justify-content: center;
      flex-shrink: 0;
    }

    /* ── OAuth consent: greeting row ── */
    .oauth-greeting-row {
      display: flex; align-items: center; justify-content: center; gap: 12px; margin-top: 4px;
    }
    .oauth-user-avatar {
      width: 40px; height: 40px; border-radius: 50%;
      background: ${({ theme }) => theme['primary-color']};
      color: #fff; font-size: 16px; font-weight: 700;
      font-family: ${({ theme }) => theme['font-family']};
      display: flex; align-items: center; justify-content: center;
      flex-shrink: 0;
      box-shadow: 0 2px 8px rgba(255,192,98,0.35);
    }
    .oauth-greeting-text { display: flex; flex-direction: column; gap: 3px; text-align: left; }
    .oauth-greeting-name {
      font-size: 14px; font-weight: 600; line-height: 1.4;
      color: ${({ theme }) => theme[theme.mainContent]['dark-text']};
      font-family: ${({ theme }) => theme['font-family']};
      margin: 0;
    }
    .oauth-switch-link {
      background: none; border: none; outline: none; appearance: none;
      -webkit-appearance: none; padding: 0; margin: 0; cursor: pointer;
      font-size: 14px;
      font-weight: 500;
      color: ${({ theme }) => theme[theme.mainContent]['gray-text']};
      font-family: ${({ theme }) => theme['font-family']};
      display: inline;
      line-height: normal;
      &:hover { opacity: 0.85; }
      &:focus { outline: none; box-shadow: none; }
      .oauth-switch-underline {
        color: #000;
        font-weight: 500;
        text-decoration: underline;
      }
    }
  }
  .ninjadash-authentication-content{
    padding: 30px 40px;
    @media only screen and (max-width: 1599px){
      padding: 30px;
    }
    .ant-form-item-label {
      > label{
        font-size: 14px;
        color: ${({ theme }) => theme[theme.mainContent]['dark-text']};
      }
    }
    .ant-form-item{
      margin-bottom: 25px;
      &:last-child {
        margin-bottom: 0px;
      }
    }
    .ant-input:focus,
    .ant-input-focused{
      box-shadow: 0 5px 20px rgba(251,53,134,.10);
    }
    .ant-input{
      &::placeholder{
        color: ${({ theme }) => theme[theme.mainContent]['extra-light-text']};
      }
    }
    .ant-form-item-explain-error{
      font-size: 13px;
      margin-top: 2px;
    }
    .ninjadash-auth-extra-links{
      display: flex;
      justify-content: space-between;
      margin-top: -5px;
      .ant-checkbox-wrapper{
        span{
          font-size: 13px;
          color: ${({ theme }) => theme[theme.mainContent]['light-text']};
        }
        .ant-checkbox{
          &+span{
            position: relative;
            top: -2px;
          }
        }
      }
      .forgot-pass-link{
        font-size: 13px;
        color: ${({ theme }) => theme['primary-color']};
      }
    }
    .btn-signin,
    .btn-reset,
    .btn-create{
      font-size: 14px;
      font-weight: 500;
      border-radius: 6px;
      width: 100%;
      min-height: 48px;
      margin-top: 25px;
    }
    .btn-reset{
      margin-top: 0;
    }

    /* ── OAuth consent: Deny button ── */
    .oauth-btn-deny,
    .oauth-btn-deny.ant-btn,
    .oauth-btn-deny.ant-btn:hover,
    .oauth-btn-deny.ant-btn:focus,
    .oauth-btn-deny.ant-btn:active,
    .oauth-btn-deny.ant-btn-default:hover,
    .oauth-btn-deny.ant-btn-default:focus,
    .oauth-btn-deny.ant-btn-default:active {
      font-size: 14px;
      font-weight: 500;
      width: 100%;
      min-height: 48px;
      margin-top: 0 !important;
      margin-bottom: 0 !important;
      border-radius: 40px !important;
      background: transparent !important;
      border: 1px solid ${({ theme }) => theme[theme.mainContent]['border-color-secondary']} !important;
      color: ${({ theme }) => theme[theme.mainContent]['light-text']} !important;
      box-shadow: none !important;
      text-shadow: none !important;
    }

    /* ── OAuth consent: content text ── */
    .oauth-consent-title {
      font-size: 14px;
      font-weight: 600;
      color: ${({ theme }) => theme[theme.mainContent]['dark-text']};
      margin-bottom: 8px;
      line-height: 1.5;
    }
    .oauth-consent-desc {
      font-size: 13px;
      color: ${({ theme }) => theme[theme.mainContent]['light-text']};
      margin-bottom: 14px;
      line-height: 1.65;
    }
    .oauth-consent-footer {
      font-size: 13px;
      color: ${({ theme }) => theme[theme.mainContent]['extra-light-text']};
      margin-bottom: 20px;
      line-height: 1.55;
    }

    /* ── OAuth consent: redirect box ── */
    .oauth-redirect-box {
      background: ${({ theme }) => theme[theme.mainContent]['general-background']};
      border: 1px solid ${({ theme }) => theme[theme.mainContent]['border-color-secondary']};
      border-radius: 6px;
      padding: 10px 14px;
      margin-bottom: 14px;
    }
    .oauth-redirect-label {
      display: block;
      font-size: 10px;
      font-weight: 700;
      text-transform: uppercase;
      letter-spacing: 0.08em;
      color: ${({ theme }) => theme[theme.mainContent]['extra-light-text']};
      margin-bottom: 4px;
    }
    .oauth-redirect-uri {
      font-size: 13px;
      color: #1890ff;
      word-break: break-all;
      font-weight: 400;
    }

    /* ── OAuth consent: button group ── */
    .oauth-btn-group {
      display: flex; flex-direction: column; gap: 10px; margin-top: 20px;
      .btn-signin { margin-top: 0 !important; }
    }

    /* ── OAuth status screens (Access Restricted / Access Denied) ── */
    .oauth-status-body { text-align: center; }
    .oauth-status-icon {
      font-size: 38px;
      color: ${({ theme }) => theme['error-color']};
      opacity: 0.85;
      margin-bottom: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .oauth-status-desc {
      font-size: 13px;
      color: ${({ theme }) => theme[theme.mainContent]['light-text']};
      line-height: 1.65;
      margin-bottom: 10px;
      strong { color: ${({ theme }) => theme[theme.mainContent]['dark-text']}; }
    }
    .oauth-status-footer {
      font-size: 13px;
      color: ${({ theme }) => theme[theme.mainContent]['extra-light-text']};
      line-height: 1.55;
    }
    .ninjadash-form-divider{
      font-size: 13px;
      color: ${({ theme }) => theme[theme.mainContent]['border-color-default']};
      text-align: center;
      position: relative;
      margin: 0 -10px 25px -10px;
      &:before{
        content: '';
        position: absolute;
        width: 100%;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        z-index: 1;
        height: 1px;
        background: ${({ theme }) => theme[theme.mainContent]['border-color-secondary']};
      }
      span{
        font-weight: 500;
        padding: 0 15px;
        display: inline-block;
        position: relative;
        z-index: 2;
        background: ${({ theme }) => theme[theme.mainContent]['white-background']};
        color: ${({ theme }) => theme[theme.mainContent]['gray-text']};
      }
    }
    .ant-input-affix-wrapper {
      &.ant-input-password{
        input{
          color: ${({ theme }) => theme[theme.mainContent]['dark-text']};
        }
      }
    }
    .ninjadash-social-login{
      display: flex;
      align-items: center;
      justify-content: center;
      margin: -6px;
      @media only screen and (max-width: 767px){
        justify-content: center;
      }
      &.signin-social{
        li{
          a{
            background-color: #fff;
          }
        }
      }
      li{
        padding:15px 6px;
        a{
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 6px;
          height: 48px;
          padding: 0 15px;
          background: ${({ theme }) => theme[theme.mainContent]['general-background']};
          color: ${({ theme }) => theme[theme.mainContent]['gray-text']};
          font-weight: 500;
          transition: background-color 0.3s;
          @media only screen and (max-width: 1399px){
            padding: 0 12px;
          }
          @media only screen and (max-width: 379px){
            height: 44px;
          }
          span:not(.anticon){
            display: inline-block;
            margin-left: 5px;
          }
          svg,
          i{
            width: 20px;
            height: 20px;
          }
          &.google-social{
            background-color: #F0654810;
            color: #F06548;
            &:hover{
              background-color: #F06548;
              svg path{
                fill: #FFFFFF;
              }
            }
            svg path{
              fill: #F06548;
            }
            div{
              height: 20px;
            }
          }
          &.facebook-social{
            background-color: #3A589B10;
            color: #3A589B;
            &:hover{
              background-color: #3A589B;
              color: #FFFFFF;
            }
          }
          &.twitter-social{
            background-color: #03A9F410;
            color: #03A9F4;
            &:hover{
              background-color: #03A9F4;
              color: #FFFFFF;
            }
          }
          &.github-social{
            background-color: #03A9F410;
            color: #090E30;
            &:hover{
              background-color: #03A9F4;
              color: #FFFFFF;
            }
          }
        }
      }
    }
    .ant-input-affix-wrapper{
      padding: 12px 20px;
    }
  }
  .ninjadash-authentication-bottom{
    text-align: center;
    padding: 15px 25px;
    border-radius: 0 0 6px 6px;
    background-color: ${({ theme }) => theme[theme.mainContent]['dark-background']};
    p{
      font-size: 14px;
      font-weight: 500;
      color: ${({ theme }) => theme[theme.mainContent]['gray-text']};
      margin-bottom: 0;
      a{
        margin-left: 6px;
        ${({ theme }) => theme['primary-color']};
      }
    }
  }
  .auth-contents{
    display: flex;
    align-items: center;
    justify-content: center;
    form{
      width: 420px;
      h1{
        font-size: 24px;
        font-weight: 600;
        margin-bottom: 45px;
        @media only screen and (max-width: 767px){
          margin-bottom: 28px;
        }
        input::placeholder{
          color: ${({ theme }) => theme['extra-light-color']};
        }
      }
      .auth-form-action{
        margin-bottom: 20px;
        display: flex;
        justify-content: space-between;
        @media only screen and (max-width: 379px){
          flex-flow: column;
          .forgot-pass-link{
            margin-top: 15px;
          }
        }
      }
    }
    #forgotPass{
      .reset-text{
        margin-bottom: 25px;
      }
      .return-text{
        margin-top: 35px;
      }
    }


  }
  .auth0-login{
    margin: -6px;
    display: flex;
    flex-wrap: wrap;
  a{
      display: inline-flex;
      align-items: center;
      justify-content: center;
      border-radius: 6px;
      height: 48px;
      padding: 0 26px;
      background: ${({ theme }) => theme['bg-color-light']};
      color: ${({ theme }) => theme['text-color']};
      font-weight: 500;
      border: 0 none;
      border-radius: 5px;
      margin: 6px;
      flex: 1;
      @media (max-width:480px){
        flex: none;
        width: 100%;
      }
  }
}
`;

export { AuthenticationWrap, OAuthAuthenticationWrap, Content, AuthFormWrap };
